import { useEffect, useRef, useState } from 'react';
import './UpdateBanner.css';

const CHECK_INTERVAL_MS = 5 * 60 * 1000; // check every 5 minutes

async function fetchMainBundleHash() {
  try {
    const res = await fetch(`/asset-manifest.json?_=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = await res.json();
    return data.files?.['main.js'] || null;
  } catch {
    return null;
  }
}

export function UpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialHash = useRef(null);

  useEffect(() => {
    let cancelled = false;

    fetchMainBundleHash().then((hash) => {
      if (!cancelled) initialHash.current = hash;
    });

    const intervalId = setInterval(async () => {
      const hash = await fetchMainBundleHash();
      if (!cancelled && hash && initialHash.current && hash !== initialHash.current) {
        setUpdateAvailable(true);
      }
    }, CHECK_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, []);

  if (!updateAvailable) return null;

  return (
    <div className="update-banner">
      <span>A new version of this app is available.</span>
      <button type="button" onClick={() => window.location.reload()}>Refresh now</button>
    </div>
  );
}
